import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { List, ListItemButton, ListItemText } from '@mui/material';

import { HOTEL_OFFER_TYPES, OFFER_TYPE_HOTEL } from '~/consts/offerTypes';
import { PROPERTY_CHANNEL_MANAGERS } from '~/consts/reservation';

type Props = {
  offerType: string;
  offerId: string;
  channelManager?: string;
};

export default function HoverNav({ offerType, offerId, channelManager }: Props) {
  return (
    <List sx={{ position: 'fixed', top: 70, width: '154px' }}>
      <ListItemButton component="a" href="#overview">
        <ListItemText primary="Overview" />
      </ListItemButton>
      <ListItemButton component="a" href="#timeline">
        <ListItemText primary="Timeline" />
      </ListItemButton>
      <ListItemButton component="a" href="#packages">
        <ListItemText primary="Packages" />
      </ListItemButton>
      {HOTEL_OFFER_TYPES.includes(offerType) && (
        <ListItemButton component="a" href="#roomPolicies">
          <ListItemText primary="Room Policy" />
        </ListItemButton>
      )}
      <ListItemButton component="a" href="#images">
        <ListItemText primary="Images &amp; Videos" />
      </ListItemButton>
      <ListItemButton component="a" href="#addons">
        <ListItemText primary="Add-ons" />
      </ListItemButton>
      {offerType === 'tour' && (
        <ListItemButton component="a" href="#travellerDetailRequirements">
          <ListItemText primary="Requirements" />
        </ListItemButton>
      )}
      {offerType !== 'tour' && (
        <ListItemButton component="a" href="#experiences">
          <ListItemText primary="Experiences" />
        </ListItemButton>
      )}
      {offerType === OFFER_TYPE_HOTEL && channelManager === PROPERTY_CHANNEL_MANAGERS.derbysoft && (
        <ListItemButton component={Link} to={`/edit-offers/${offerId}/offer-inventory`}>
          <ListItemText primary="Room Inventory" />
        </ListItemButton>
      )}
    </List>
  );
}
